import { Provider } from 'react-redux';
import configureStore from './configureStore';
import React from "react";
import ReactDOM from "react-dom";
import ReactGA from 'react-ga';
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";
import "./assets/css/material-dashboard-react.css";
import indexRoutes from "./routes/index";
import { setUserIpAddress } from './helpers/utility.helper';
import { getYears, getRoles } from './helpers/initial-service-calls';

ReactGA.initialize('UA-133671159-1');

const hist = createBrowserHistory();

setUserIpAddress();
getYears();
getRoles();

ReactDOM.render(<Provider store={configureStore()}>
    <Router history={hist}>
        <Switch>
            {indexRoutes.map((prop, key) => {
                return <Route path={prop.path} component={prop.component} key={key} />;
            })}
        </Switch>
    </Router></Provider>,
    document.getElementById("root")
);


// WEBPACK FOOTER //
// ./src/index.js